import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';
import { Buffer } from 'buffer';

import Loader from '../components/Loader';
import NotificationBox from '../components/layout/NotificationBox';
import TrialInvoiceDialog from '../components/trial/TrialInvoiceDialog';
import ApiClient from '../loopback/apiClient';
import withRouter, { RouteType } from '../hoc/withRouter';

type MatchType = {
  search: string;
}

type Props = RouteType<MatchType>;

type State = {
  paymentConfirmationFailed?: boolean;
  invoiceDialogOpen?: boolean;
  paymentConfirmation?: any;
  paymentToken: any;
}

class PaymentSuccessView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const {
      router,
    } = this.props;
    const query = queryString.parse(router.location.search) as any;
    if (query && query.paymentToken) {
      const paymentToken = JSON.parse(Buffer.from(query.paymentToken, 'base64').toString('ascii'));
      this.state = {
        paymentToken,
      };
    } else {
      this.state = {
        paymentConfirmationFailed: true,
        paymentToken: null,
      };
    }
  }

  componentDidMount() {
    const { paymentToken } = this.state;
    if (paymentToken) {
      ApiClient.confirmPayment(paymentToken)
        .then((paymentConfirmation) => {
          this.setState({
            paymentConfirmation,
            invoiceDialogOpen: true,
          });
        })
        .catch(() => {
          this.setState({ paymentConfirmationFailed: true });
        });
    }
  }

  render() {
    const { paymentConfirmation, paymentConfirmationFailed, invoiceDialogOpen } = this.state;
    const { router } = this.props;
    return (
      <div>
        {!paymentConfirmation && !paymentConfirmationFailed && <Loader isLoading />}
        {paymentConfirmation && (
          <div>
            <TrialInvoiceDialog
              isOpen={!!invoiceDialogOpen}
              onClose={() => {
                this.setState({ invoiceDialogOpen: false });
                router.navigate('/enrollments');
              }}
              enrollment={paymentConfirmation.enrollment}
              guidingText={
                paymentConfirmation.clearingType === 'rec'
                  ? <FormattedMessage id="payment.invoiceConfirmationTextRec" />
                  : <FormattedMessage id="payment.invoiceConfirmationText" />
              }
              trial={paymentConfirmation.trial}
              navigate={router.navigate}
            />
          </div>
        )}
        {paymentConfirmationFailed && (
          <NotificationBox error>
            <FormattedMessage id="payment.failed" />
          </NotificationBox>
        )}
      </div>
    );
  }
}

export default withRouter(PaymentSuccessView);
